import { render, staticRenderFns } from "./invoiceRecord.vue?vue&type=template&id=b496d89e&"
import script from "./invoiceRecord.vue?vue&type=script&lang=js&"
export * from "./invoiceRecord.vue?vue&type=script&lang=js&"
import style0 from "./invoiceRecord.vue?vue&type=style&index=0&id=b496d89e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports